<template>
    <div :id="modalId" class="modal small">
        <div
            class="shadow corners-10 align-h-center tw-mx-auto tw-flex tw-max-w-lg tw-flex-col tw-overflow-visible tw-border tw-bg-white tw-text-[#000C17] dark:tw-border-[#445F74] dark:tw-bg-[#081825] dark:tw-text-white"
        >
            <div class="modal-container tw-relative tw-p-4 md:tw-p-7">
                <h1
                    class="tw-mb-2 tw-text-center tw-text-xl tw-font-bold md:tw-text-2xl"
                >
                    Subscribe to Calendar
                </h1>

                <p class="tw-mb-4 tw-text-center tw-text-sm tw-leading-normal">
                    Here you can subscribe to {{ toCapitalCase(brand) }}'s
                    Lesson Calendar - Apple Calendar, Google Calendar, Outlook,
                    and Yahoo Calendar are all supported.
                </p>

                <div
                    v-if="subscriptionCalendarId"
                    class="tw-relative tw-text-center"
                    style="width: 100%"
                >
                    <a
                        :href="`https://www.addevent.com/calendar/${this.subscriptionCalendarId}`"
                        target="_blank"
                        class="tw-btn-primary tw-mb-2 tw-block tw-w-full tw-rounded-full tw-bg-[#00101D] tw-py-2 tw-font-bebas-neue tw-text-lg tw-uppercase tw-text-white hover:tw-bg-[#3F3F46] dark:tw-bg-white dark:tw-text-[#00101D] dark:hover:tw-bg-[#223F57] dark:hover:tw-text-white"
                    >
                        <i class="fas fa-calendar-plus tw-mr-1"></i>
                        Subscribe to calendar
                    </a>
                </div>

                <p
                    v-if="subscriptionCalendarId"
                    class="tw-mb-2 tw-text-center tw-text-xs tw-italic"
                >
                    Any upcoming releases will automatically show up in this
                    calendar as they are scheduled by the
                    {{ toCapitalCase(brand) }} Team.
                </p>

                <p
                    v-if="hasSingleEvent"
                    class="tw-mb-2 tw-text-center tw-text-sm tw-leading-normal"
                >
                    Or you can subscribe to this event only by clicking the
                    button below.
                </p>

                <div
                    v-if="hasSingleEvent"
                    class="pointer tw-relative tw-w-full tw-text-sm tw-leading-normal"
                >
                    <a
                        :href="calendarURL"
                        target="_blank"
                        class="tw-btn-primary tw-mb-1 tw-w-full tw-bg-[#00101D] tw-text-white hover:tw-bg-[#3F3F46] dark:tw-bg-white dark:tw-text-[#00101D] dark:hover:tw-bg-[#223F57] dark:hover:tw-text-white"
                    >
                        <i class="fas fa-calendar-plus tw-mr-1"></i>
                        Subscribe to this event only
                    </a>
                </div>

                <p
                    v-if="hasSingleEvent"
                    class="tw-mb-2 tw-text-center tw-text-xs tw-italic"
                >
                    Only this event will be added to your calendar.
                </p>
            </div>
        </div>
    </div>
</template>
<script>
import UtilsHelpers from "../../assets/js/helper-functions/utils.js";
import AddEventDropdown from "./AddEventDropdown.vue";
import ThemeClasses from "../../mixins/ThemeClasses";
import InfoModal from "@collections/Modal/InfoModal.vue";
import ModalRenderer from "@collections/Modal/ModalRenderer.vue";

export default {
    name: "AddEventModal",
    components: {
        "add-event-dropdown": AddEventDropdown,
        InfoModal,
        ModalRenderer,
    },
    mixins: [ThemeClasses],
    props: {
        modalId: {
            type: String,
            default: "addToCalendarModal",
        },
        brand: {
            type: String,
            default: () => "Musora",
        },
        singleEvent: {
            type: Object,
            default: () => ({
                title: null,
                date: null,
            }),
        },
        subscriptionCalendarId: {
            type: String,
            default: "",
        },
        subscriptionType: {
            type: String,
            default: "event",
        },
        subscriptionId: {
            type: String,
            default: "event",
        },
        toggleSubscribe: {
            type: Function,
            default: () => {},
        },
    },
    data() {
        return {
            singleEventDropdown: false,
            subscriptionCalendarDropdown: false,
        };
    },
    computed: {
        calendarURL() {
            if (this.subscriptionType === "calendar") {
                return `https://www.addevent.com/calendar/${this.subscriptionId}`;
            }

            return `https://www.addevent.com/event/${this.subscriptionId}`;
        },
        hasSingleEvent() {
            return this.subscriptionType === "event";
        },
    },
    watch: {
        singleEventDropdown(val) {
            if (val) {
                this.subscriptionCalendarDropdown = false;
            }
        },
        subscriptionCalendarDropdown(val) {
            if (val) {
                this.singleEventDropdown = false;
            }
        },
    },
    mounted() {
        document.body.addEventListener("click", () => {
            this.singleEventDropdown = false;
            this.subscriptionCalendarDropdown = false;
        });

        window.addEventListener("modalClose", () => {
            this.$emit("modalClose");
        });
    },
    methods: {
        toCapitalCase: (string) => UtilsHelpers.toCapitalCase(string),
        toggleModal() {
            this.toggleSubscribe();
        },
    },
};
</script>
